import { type CardData } from '@xing-com/crate-dream-machine-types';

export const getAlertDataForCard = (
  card: CardData
): {
  keywords: string;
  location?: string | null;
} | null => {
  if (card.type === 'Tutorial') {
    return null;
  }

  const company = card?.company || card.fallbackCompany;
  const location = company?.address?.city || '';
  const keywords = [card.jobTitle, card.company?.companyName]
    .filter((item) => !!item)
    .join(' ');

  return { location, keywords };
};
